export { MeetingsTabsViewAdaptive as default } from "../../../navigation/ResponsiveScreens";
export type { MeetingsTabKey } from "./MeetingsTabsView.types";
